import trackingObject from './tagging-content.json'

function isElementVisible(el, offset = 0) {
	const rect = el.getBoundingClientRect();
	const vWidth = window.innerWidth || window.documentElement.clientWidth;
	const vHeight = window.innerHeight || window.documentElement.clientHeight;

	// Check if the element is out of bounds
	if (rect.top > vHeight - offset) return false;

	// Return true if any of the above disjunctions are false
	return true;
}

function getCurrentSection() {
	const trackingSections = document.querySelectorAll('[data-tracking*="section-"]');
	const {scrollTop, offsetHeight} = document.documentElement;
	const {innerHeight} = window;
	const bottomOfWindow = Math.round(scrollTop) + innerHeight === offsetHeight;

	for (let x = trackingSections.length - 1; x >= 0; x--) {
		const sectionName = trackingSections[x].dataset.tracking.split('section-')[1];
		const footer = document.querySelector('footer');
		const stickyFooter = document.querySelector('#stickyFooter');

		// if 'footer' then should just check to see if it passes the bottom of the screen
		// Footer should be dominant section
		// if (sectionName === 'footer' && (window.innerHeight >= document.querySelector('footer').offsetTop - document.documentElement.scrollTop - document.querySelector('#nav').getBoundingClientRect().height)) {
		// 	return ('footer');
		// }

		if (sectionName === 'footer' && stickyFooter && (isElementVisible(footer, stickyFooter.getBoundingClientRect().height))) {
			return ('footer');
		}



		if (trackingSections[x].offsetTop <= document.documentElement.scrollTop && document.documentElement.scrollTop < (trackingSections[x].offsetTop + trackingSections[x].offsetHeight)) {
			return (sectionName);
		}
	}
}

export const fireGA = (tag, elem = {}) => {
	let curTag = structuredClone(trackingObject[tag]); // must used structuredClone to avoid object mutation since object valuation is by reference
	// console.log(elem)
	if (curTag.hasOwnProperty('clickText')) {
		if (curTag.clickText === '[TEXT]') {
			curTag.clickText = elem.innerText.toLowerCase();
		}
	}

	if (curTag.hasOwnProperty('siteSection')) {
		if (curTag.siteSection === '[SECTION]') {
			curTag.siteSection = getCurrentSection();
		}
	}

	if (curTag.hasOwnProperty('userActionTaken')) {
		if (curTag.userActionTaken === '[USER ACTION]') {
			curTag.userActionTaken = elem.userActionTaken;
		}
	}

	window.dataLayer.push(curTag);
}

export const fireScrollGA = (tag) => {
	let curTag = trackingObject[tag] || false;
	if (curTag) {
		if (curTag['fired']) {
			return;
		}
		else {
			trackingObject[tag]['fired'] = true;
			// console.table(curTag);
			window.dataLayer.push(curTag);
		}
	}

}

export const fireSupGA = (obj) => {
	const supObj = {
		"event": "key-interaction",
		"lineOfBusiness": "csbb: interaction",
		"userActionTaken": "navigate",
		"buttonLocation": "anchor",
		"siteSection": "anchor",
	}

	let newObj = Object.assign(supObj, obj);
	window.dataLayer.push(newObj);
}

export function trackScrolling() {

	window.addEventListener('scroll', function () {
		// Added some logic for the footer
		const trackingSections = document.querySelectorAll('[data-tracking*="section-"]');

		const {scrollTop, offsetHeight} = document.documentElement;
		const {innerHeight} = window;
		const bottomOfWindow = Math.round(scrollTop) + innerHeight === offsetHeight;
		trackingSections.forEach((section) => {

			const sectionName = section.dataset.tracking.split('section-')[1];
			// console.log('sectionName ', sectionName)

			const footer = document.querySelector('footer');
			const stickyFooter = document.querySelector('#stickyFooter');

			if ((sectionName === 'footer' && stickyFooter) && (isElementVisible(footer, stickyFooter.getBoundingClientRect().height))) {
				// console.log('sectionName ', sectionName)
				fireScrollGA(sectionName);
			}

			// For tracking use parent container of section for more accuracy
			else if ((sectionName !== 'footer') && section.offsetTop < document.documentElement.scrollTop && (document.documentElement.scrollTop < section.offsetTop + section.offsetHeight)) {
				// console.log('sectionName ', sectionName)
				fireScrollGA(sectionName);
			}

			// if 'legal' or 'footer' then should just check to see if it passes the bottom of the screen
			// else if ((sectionName === 'legal') && (window.innerHeight >= document.querySelector('#disclaimers').offsetTop - document.documentElement.scrollTop - document.querySelector('#nav').getBoundingClientRect().height)) {
			//   console.log('sectionName ', sectionName)
				// fireScrollGA(sectionName);
			// }
		});
	});
}
